import { render, staticRenderFns } from "./ApprovalHistoryFront.vue?vue&type=template&id=c70ad7f0&scoped=true"
import script from "./ApprovalHistoryFront.vue?vue&type=script&lang=js"
export * from "./ApprovalHistoryFront.vue?vue&type=script&lang=js"
import style0 from "./ApprovalHistoryFront.vue?vue&type=style&index=0&id=c70ad7f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70ad7f0",
  null
  
)

export default component.exports